<!-- Card 1 -->
<div class="roteiro-card mx-2 my-1" >
  <!-- Header do Card -->
  <div class="roteiro-card--header d-flex" [ngClass]="  
        {
          'pendente-distri': dados.porcentagem < 100 && !dados.RoteiroTransportadora,
          'total-distri': dados.porcentagem == 100 && !dados.RoteiroTransportadora,
          'pendente-transp': dados.porcentagem > 0 && dados.porcentagem < 100 && dados.RoteiroTransportadora,
          'total-transp': dados.porcentagem == 100 && dados.RoteiroTransportadora,
          'header-crossdocking-finalizado': dados.IdRoteiroSituacao === 5  && isCrossdocking,
          'header-crossdocking': isCrossdocking && (dados.IdRoteiroSituacao == 1 || dados.IdRoteiroSituacao == 2 || dados.IdRoteiroSituacao == 3 || dados.IdRoteiroSituacao == 4)
          
        }
        "
      >
    <div class="titulo" title='{{ dados.tooltip }}'>
        <img class="me-2" [src]="dados.icone" >
        <span class='roteiro-numero' title='{{dados.nome_motorista.trim()}}'> <span>{{dados.roteiro}} </span> <span *ngIf="!dados.RoteiroTransportadora "> | {{dados.nome_motorista ? dados.nome_motorista.trim().split(' ')[0] : '-'}}</span></span>
    </div>

    <ng-container *ngIf="isCrossdocking; else statusPadrao">
      <img *ngIf="dados.IdRoteiroSituacao == 1" src='assets/img/icons/card_titulo_pendente.svg' alt="Não iniciado" class="align-items-baseline">
      <img *ngIf="dados.IdRoteiroSituacao == 2" src='assets/img/icons/card_play.svg' alt="Em rota" class="align-items-baseline">
      <img *ngIf="dados.IdRoteiroSituacao == 3" src='assets/img/icons/card_pausa.svg' alt="Pausado" class="align-items-baseline">
      <img *ngIf="dados.IdRoteiroSituacao == 4" src='assets/img/icons/icon-sem-sinal.svg' alt="Sem sinal" class="align-items-baseline">
      <img *ngIf="dados.IdRoteiroSituacao == 5" src='assets/img/icons/check-white.svg' alt="Finalizado">
    </ng-container>

    <ng-template #statusPadrao>

        <div class="barra-progresso d-flex align-self-center" title='Percentual do Roteiro Completo'>
    
          <img *ngIf="dados.IdRoteiroSituacao == 1;else pausa" src='assets/img/icons/card_titulo_pendente.svg'  alt="Pendente" class="align-items-baseline">
          <ng-template #pausa>
            <img *ngIf="dados.IdRoteiroSituacao == 3;else finalizado" src='assets/img/icons/card_pausa.svg'  alt="Pausa" class="align-items-baseline">
          </ng-template>
          <ng-template #finalizado>
            <img *ngIf="dados.porcentagem == 100;else inicializado" src='assets/img/icons/card_check.svg'  alt="Pausa" >
          </ng-template>
          <ng-template #inicializado>
            <img  src='assets/img/icons/card_play.svg'  alt="Pausa" class="align-items-baseline">
          </ng-template>
        
        <div class="ms-1 progress float-rigth">
          <div class="progress-bar progress-bar-striped" role="progressbar" [ngClass]="{'bg-success': dados.porcentagem == 100,  'bg-danger': dados.porcentagem != 100 }" [ngStyle]="{'width': dados.porcentagem+'%'}" attr.aria-valuenow="{{dados.porcentagem}}" 
            aria-valuemin="0" aria-valuemax="100"></div>
        </div>
        <div class="progress--porcentagem"  [ngClass]="{
            'pend-color' : dados.porcentagem > 0,
            'total-color': dados.porcentagem == 100
          }">
          {{dados.porcentagem}}%
        </div>
      </div>

    </ng-template>

    
  </div>

  <!-- Corpo do card -->
  <div class="roteiro-card--body">
    <div class="roteiro-card--info">
      <div class="info-roteiro" title='Motorista e Veículo'>
        <img src="assets/img/icons/car-steering-wheel.svg" width="18px" alt=""> 
        <span class="info-motorista"> {{ dados.RoteiroTransportadora   ? 'Transportadora: ' + dados.nome_motorista : dados.placaVeiculo + ' | ' + dados.veiculo }} </span>
      </div>

      <div *ngIf="!isCrossdocking" class="info-km" title='Kilometragem Rodada' >
        {{ dados.Distancia? dados.Distancia.toFixed(0) : 0}} Km
      </div>

    </div>

    <ng-container *ngIf="!isCrossdocking">
      <span class="mt-2 sub-titulo-cliente">Clientes</span>
      <div class="roteiro-card--dados">

      
        <div class="d-flex" title='Total de Clientes'>
          {{totais.totalCliente}}
        </div>

      
        <div  class="d-flex" title='Clientes Atendidos'>
          <img src="assets/img/icons/card_entregue.svg" alt="entregues" class="me-1" > <span> {{totais.totalClienteEntregue}}</span>
        </div>

      
        <div class="d-flex"  title='Clientes Não Atendidos'>
          <img src="assets/img/icons/card_recusada.svg"  alt="Não atendidos" class="me-2" > <span>{{totais.totalClienteNaoAtendidos + totais.totalClienteRecusado }}</span>
        </div>

      
        <div class="d-flex" title='Clientes em Análise'>
            <img src="assets/img/icons/card_em_analise.svg" alt="Em análise" class="me-2"> <span>{{totais.totalClienteEmAnalise}}</span>
          </div>

      
        <div title='Clientes Não Visitados'>
          <img src="assets/img/icons/card_pendente.svg"  alt="Pendente" class="me-1" > <span> {{totais.totalClienteNaoVisitado}} </span>
        </div>

      </div>
    </ng-container>
    <ng-container *ngIf="isCrossdocking">
      <div class="crossdocking-card-container">
          <div class="crossdocking-row">
            <div class="crossdocking-card--info">
              <span class="crossdocking-card--titulo">Roteiros</span>
              <span class="crossdocking-card--dados">{{dados.roteirosCrossdocking.length}}</span>
            </div>
            <div class="crossdocking-card--info">
              <span class="crossdocking-card--titulo">Motorista</span>
              <span class="crossdocking-card--dados">{{dados.nome_motorista}}</span>
            </div>
          </div>
          <div class="crossdocking-row">
            <div class="crossdocking-card--info">
              <span class="crossdocking-card--titulo">Paletes</span>
              <span class="crossdocking-card--dados">{{dados.totalPaletes}}</span>
            </div>
            <div class="crossdocking-card--info">
              <span class="crossdocking-card--titulo">Peso/cub.</span>
              <span class="crossdocking-card--dados">{{dados.PesoBrutoTotal}}kg - {{dados.Cubagem}}m³</span>
            </div>
          </div>      
      </div>
    </ng-container>

  </div>

</div>
